import { AvatarGroup } from "@mui/material";

import { isMobile } from "@hooks/layout";

import styled from "styled-components";

export const AvatarGroupWrapper = styled(AvatarGroup)<{ $isSmall: boolean; isDetails: boolean }>`
  && {
    ${({ isDetails }) =>
      isDetails
        ? `
  display: flex;
    flex-direction: column;

    width: 100%;
    gap: 4px;

    .MuiAvatarGroup-avatar {
      align-items: center;
    }

    .MuiAvatar-circular {
      margin: 0;
      border: 1px solid #ffdca8;
      width: ${({ $isSmall }) => ($isSmall ? "24px" : "34px")};
      height: ${({ $isSmall }) => ($isSmall ? "24px" : "34px")};
      color: #ffdca8;
      font-family: "Kaisei Opti";
      font-size: 0.75rem;
      cursor: pointer;
    }

    ${isMobile} {
      align-items: flex-end;
    }
  `
        : `
      .MuiAvatarGroup-avatar {
      border: 1px solid #ffdca8;
      width: ${({ $isSmall }) => ($isSmall ? "24px" : "34px")};
      height: ${({ $isSmall }) => ($isSmall ? "24px" : "34px")};
      color: #ffdca8;
      font-family: "Kaisei Opti";
      font-size: 0.75rem;
      cursor: pointer;
    }
  `}
  }
`;
